export const KeyboardFocus = {
    /** Out of the tab order — reachable only from code, as a focus target after a move. */
    DISABLED: -1,
    FOCUSABLE: 0,
};
